import { render, staticRenderFns } from "./EzDateInput.vue?vue&type=template&id=f1c24824&scoped=true&"
import script from "./EzDateInput.vue?vue&type=script&lang=js&"
export * from "./EzDateInput.vue?vue&type=script&lang=js&"
import style0 from "./EzDateInput.vue?vue&type=style&index=0&id=f1c24824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c24824",
  null
  
)

export default component.exports